import React from 'react';
import {Earth} from 'react-planetary/index'

function App() {
  return <Earth />
}

export default App;
